import { Col } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addCardProps } from '../../actions';
import { IState } from '../../graphql/types';
import { handleInputChange } from '../utils';
import CardFormTextArea from './CardFormTextArea';

import styles from './CardForm.module.css';

const HighlightForm: React.FC<{ saving: boolean }> = ({ saving }) => {
  const dispatch = useDispatch();
  const text = useSelector<IState, string | undefined>(
    state => state.cardProps?.text as string | undefined
  );

  return (
    <div className={styles.formWrapper}>
      <Col span={24}>
        <CardFormTextArea
          name="highlightText"
          fieldLabel="Text"
          defaultValue={text}
          rows={7}
          className={styles.highlightTextArea}
          autoFocus
          showCount
          maxLength={500}
          onChange={handleInputChange(value =>
            dispatch(addCardProps('text', value))
          )}
          disabled={saving}
          placeholder="Is there a key point you want to shout from the mountaintops, or at least particuarly emphasize? Put it here and we’ll highlight it for you. "
        />
      </Col>
    </div>
  );
};

export default HighlightForm;
